module.exports = __webpack_public_path__ + "static/img/jinbi-night-blue.16255f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/jinbi-night-blue.jpg
// module id = dFVh
// module chunks = 9